import React, { Component } from 'react';
import TournamentMatch from './TournamentMatch';

export default class TournamentKeys extends Component {
    
    renderRounds() {

        return (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative' }}>

                { 
                    this.props.rounds.map((round, key) => {

                        return (
                            <div style={{ marginRight: 40 }}>
                                <h4 style={{ position: 'absolute', top: 0, minWidth: 100, paddingLeft: 8 }}>{key === this.props.rounds.length - 1 ? 'Final' : `Rodada ${key + 1}`}</h4>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', height: this.props.rounds[0].matches.length * 150, marginTop: 80, marginRight: 50 }}>
                                    {
                                        round.matches.map((match, matchKey) => {

                                            return <TournamentMatch view={'key'} {...this.props} round={key} match={match} index={matchKey}/>
                                            
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })
                }

            </div>
        )
    }

    render() {
        return (
            <div style={{ padding: 25 }}>
                { this.props.rounds && this.props.rounds.length ? this.renderRounds() : null }
            </div>
        )
    }
}